/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useContext } from 'react';
// import loadable from '@loadable/component';
import { bool, string, object } from 'prop-types';
import Media from 'react-media';
import { useMediaQuery } from '@material-ui/core';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';

import ProductImageUIMobile from './v1/ProductImageUIMobile';
import ProductImageUIMobileV2 from './v2/ProductImageUIMobile';
import GraphqlProductImageUI from './v1/GraphqlProductImageUI';
import GraphqlProductImageUIV2 from './v2/GraphqlProductImageUI';
import ProductImageUIGrid from './v2/ProductImageUIGrid';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import useIsPlaPage from '../../../../../helpers/hooks/useIsPlaPage';

// const LoadableProductImageUIMobile = loadable(() => import(/* webpackChunkName: "v1_ProductImageUIMobile" */ './v1/ProductImageUIMobile'));
// const LoadableProductImageUIMobileV2 = loadable(() => import(/* webpackChunkName: "v2_ProductImageUIMobile" */ './v2/ProductImageUIMobile'));
// const LoadableGraphqlProductImageUI = loadable(() => import(/* webpackChunkName: "v1_GraphqlProductImageUI" */ './v1/GraphqlProductImageUI'));
// const LoadableGraphqlProductImageUIV2 = loadable(() => import(/* webpackChunkName: "v2_GraphqlProductImageUI" */ './v2/GraphqlProductImageUI'));

const ProductImageUI = ({
    brand,
    content,
    isSmartGiftEnabled,
    product,
    productName,
    productNameDisplay,
    selectedSku,
    location,
    productBaseContent,
    smartGiftLetThemKnowSection,
    pdpVariantName,
    isPdpRedesignEnabled,
    showProductTitleTop,
    isPdpRedesignShortEnabled,
}) => {
    const { featureFlags = {}, presentation_family = '' } = useContext(CrossMerch);
    const isAltV3 = featureFlags['is-pdp-alt-v3-enabled'] || false;
    const selectedSkuBasedAltImages = featureFlags['has-alt-images-pim-sourced'] || false;
    const isPlaPage = useIsPlaPage();
    const isDesktop = useMediaQuery('(min-width: 601px)');
    const plaAltImageHorizontal =  useMediaQuery('(max-width: 1279px) and (min-width:1026px)') && isPlaPage;
    // GRID TEST
    if (featureFlags['is-pdp-grid-enabled'] && pdpVariantName === 'grid') {
        const mediaQueries = {
            small: '(max-width: 599px)',
            medium: '(min-width: 600px) and (max-width: 1199px)',
            large: '(min-width: 1200px)',
        };
        return (
            <Media queries={mediaQueries}>
                {(matches) => (
                    <>
                        {matches.small && !isAltV3 && (
                            <ProductImageUIMobileV2
                                content={content}
                                presentation_family={presentation_family}
                                product={product}
                                productBaseContent={productBaseContent}
                                productName={productName}
                                productNameDisplay={productNameDisplay}
                                selectedSku={selectedSku}
                                featureFlags={featureFlags}
                                isPdpRedesignEnabled={isPdpRedesignEnabled}
                                showProductTitleTop={showProductTitleTop}
                                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                                selectedSkuBasedAltImages={selectedSkuBasedAltImages}
                            />
                        )}
                        {(matches.medium || matches.large || isAltV3) && (
                            <ProductImageUIGrid
                                brand={brand}
                                // TODO remap to product, data duplicate prop
                                data={product}
                                isSmartGiftEnabled={isSmartGiftEnabled}
                                location={location}
                                productBaseContent={productBaseContent}
                                selectedSku={selectedSku}
                                smartGiftLetThemKnowSection={smartGiftLetThemKnowSection}
                                featureFlags={featureFlags}
                                presentation_family={presentation_family}
                                plaAltImageHorizontal={plaAltImageHorizontal}
                                selectedSkuBasedAltImages={selectedSkuBasedAltImages}
                            />
                        )}
                    </>
                )}
            </Media>
        );
    }

    return (
        <DesktopMobile
            mobile={() => (
                featureFlags['is-pdp-v-2-enabled'] ? (
                    <ProductImageUIMobileV2
                        content={content}
                        presentation_family={presentation_family}
                        product={product}
                        productBaseContent={productBaseContent}
                        productName={productName}
                        productNameDisplay={productNameDisplay}
                        selectedSku={selectedSku}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        featureFlags={featureFlags}
                        showProductTitleTop={showProductTitleTop}
                        isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                        selectedSkuBasedAltImages={selectedSkuBasedAltImages}
                    />
                ) : (
                    <ProductImageUIMobile
                        content={content}
                        presentation_family={presentation_family}
                        product={product}
                        productBaseContent={productBaseContent}
                        productName={productName}
                        productNameDisplay={productNameDisplay}
                        selectedSku={selectedSku}
                        featureFlags={featureFlags}
                        brand={brand}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        showProductTitleTop={showProductTitleTop}
                        isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                        selectedSkuBasedAltImages={selectedSkuBasedAltImages}
                    />
                )
            )}
            desktop={() => (
                // eslint-disable-next-line no-nested-ternary
                featureFlags['is-pdp-v-2-enabled'] ? (
                    <GraphqlProductImageUIV2
                        brand={brand}
                        // TODO remap to product, data duplicate prop
                        data={product}
                        isSmartGiftEnabled={isSmartGiftEnabled}
                        location={location}
                        productBaseContent={productBaseContent}
                        selectedSku={selectedSku}
                        smartGiftLetThemKnowSection={smartGiftLetThemKnowSection}
                        featureFlags={featureFlags}
                        presentation_family={presentation_family}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        selectedSkuBasedAltImages={selectedSkuBasedAltImages}
                    />

                ) : (
                    <GraphqlProductImageUI
                        brand={brand}
                        // TODO remap to product, data duplicate prop
                        data={product}
                        isSmartGiftEnabled={isSmartGiftEnabled}
                        location={location}
                        presentationFamily={presentation_family}
                        productBaseContent={productBaseContent}
                        selectedSku={selectedSku}
                        smartGiftLetThemKnowSection={smartGiftLetThemKnowSection}
                        featureFlags={featureFlags}
                        plaAltImageHorizontal={plaAltImageHorizontal}
                        isPlaPage={isPlaPage}
                        selectedSkuBasedAltImages={selectedSkuBasedAltImages}
                    />

                ))}
            breakpoint={600}
        />
    );
};

ProductImageUI.defaultProps = {
    pdpVariantName: '',
    isPdpRedesignEnabled: false,
    showProductTitleTop: false,
    isPdpRedesignShortEnabled: false,
};

ProductImageUI.propTypes = {
    brand: object.isRequired,
    content: object.isRequired,
    isSmartGiftEnabled: bool.isRequired,
    product: object.isRequired,
    productName: string.isRequired,
    productNameDisplay: string.isRequired,
    selectedSku: object.isRequired,
    location: object.isRequired,
    productBaseContent: object.isRequired,
    smartGiftLetThemKnowSection: object.isRequired,
    pdpVariantName: string,
    isPdpRedesignEnabled: bool,
    showProductTitleTop: bool,
    isPdpRedesignShortEnabled: bool,
};

export default (ProductImageUI);
